import React from 'react';
import './styles.css';
import { ECE, ADMIN, COMMENT_OPEN } from '@BUP/constants';
import { PageLayout, MessagesList } from '@BUP/components';
import { Breadcrumb, Col } from 'antd';
import { isRoleAllowed } from '@BUP/services/BraveUp';
import { useAuth, useInboxMessages } from '@BUP/hooks';
import { FolderOpenOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const BupInboxPage = () => {
  const { user } = useAuth();
  const [t] = useTranslation();
  const userRole = user?.roles?.type;
  const { isLoading, messages, error, setMessageState } = useInboxMessages();
  const filterMessages = isRoleAllowed(userRole, [ECE, ADMIN])
    ? messages.filter((message) => message.state === COMMENT_OPEN)
    : messages;

  return (
    <PageLayout>
      <div className="inbox-page-container">
        <Breadcrumb separator=">" className="modebup-breadcrumb">
          <Breadcrumb.Item>
            {t('pages.modeBup.inbox.breadcrumbText1')}
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {t('pages.modeBup.inbox.breadcrumbText2')}
          </Breadcrumb.Item>
        </Breadcrumb>
        <Col className="inbox-list-container" xs={24} lg={22} xxl={18}>
          <MessagesList
            title={t('pages.modeBup.inbox.title')}
            titleIcon={<FolderOpenOutlined />}
            messages={filterMessages}
            isLoading={isLoading}
            error={error}
            handleSetMessageState={setMessageState}
          />
        </Col>
      </div>
    </PageLayout>
  );
};

export default BupInboxPage;
